// extracted by mini-css-extract-plugin
export default {"card":"ProductCard_card__tlh3t","text":"ProductCard_text__QQNrU","container":"ProductCard_container__p-IUw","productInfoBox":"ProductCard_productInfoBox__qe9Gu"};